
<!-- TODO MBO en attente retour AIFE champs nature Marche -->
<!-- <app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"

	[value]="radioButtonValue"

	[label]="step2.getspan4"
	[type]="'radio'"
	[rule]="'required'"
	[errorMessage]="{'required' : 'ctr_1094_HorsDef'}"
	[radios]="[
		{
			label: step2.gettravaux,
			value: travauxValue
		},
		{
			label: step2.getfournitures,
			value: fournituresValue
		},
		{
			label: step2.getservices,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input> -->

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="annulation?.objet"
[label]="step2.getobjet"
[type]="'text'" [rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_107', 'minLength' : 'ctr_123'}"
[name]="getUid()+'_SepAtt_objet'">
</app-form-input>

<span class="d-block" >{{ step2.getspan4  | translate }}</span>

<app-type-lieu *ngIf="!cbChecked()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_221'}"
[lieuExecutionLivraison]="annulation?.lieuExecution"></app-type-lieu>
<app-form-input-error *ngIf="!cbChecked()" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<span class="d-block" *ngIf="!cbChecked()">{{ step2.getspan5  | translate }}</span>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="annulation?.lieuExecutionLivraison"
[label]="step2.getlieuexecutionlivraison"
[checkboxDestination]="'object'"
[type]="'checkbox'" [rule]="''"
[name]="getUid()+'_SepAtt_lieuExecutionCB'">
</app-form-input>

<app-type-lieu *ngIf="!cbChecked()"  [uid]="'lieuLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_175', 'pattern' : 'ctr_222'}"
 [lieuExecutionLivraison]="annulation?.lieuLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="!cbChecked()" [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-type-lieu *ngIf="cbChecked()" [uid]="'lieuExecutionLivraison'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[errorMessage]="{'minLength':'ctr_176', 'pattern' : 'ctr_43'}"
 [lieuExecutionLivraison]="annulation?.lieuExecutionLivraison"></app-type-lieu>
 <app-form-input-error *ngIf="cbChecked()" [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>

<!---->

<app-type-objCPV  [uid]="getUid()" [parentForm]="parentForm" [cpv]="annulation?.description?.cpv"></app-type-objCPV>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="annulation?.typeProcedure"
[label]="step2.getprocedure"
[type]="'text'"
[name]="getUid()+'_SepAtt_procedure'">
</app-form-input>

